module.exports = __webpack_public_path__ + "img/logo.c1f68a97.png";